import {
    GET_METERING_CONSUMPTION_START,
    GET_METERING_CONSUMPTION_SUCCESS,
    GET_METERING_CONSUMPTION_ERROR,
    GET_METERING_CONSUMPTION_RESET
} from "../actions/metering";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export function consumption(state = defaultState, { type, payload, error }) {
    switch (type) {
        case GET_METERING_CONSUMPTION_START:
            return {
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case GET_METERING_CONSUMPTION_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                consumption: payload
            };
        case GET_METERING_CONSUMPTION_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { message: error }
                }
            };
        case GET_METERING_CONSUMPTION_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
